import React from 'react';
import { Mail, Phone, Instagram, MapPin, Building2 } from 'lucide-react';
import { brandInfo, footerLinks } from '../data/mock';

const Footer = () => {
  return (
    <footer id="contact" className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <a href="/" className="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_puter-klub/artifacts/wdaauptq_Logo_V%20%281%29.png" 
                alt="Ganetov Premium Puter" 
                className="footer-logo-image"
              />
            </a>
            <div className="footer-business-info">
              <p className="business-name">{brandInfo.company}</p>
              <div className="business-address">
                <MapPin size={14} />
                <span>{brandInfo.address}, {brandInfo.city}</span>
              </div>
            </div>
          </div>

          <nav className="footer-nav">
            <h4 className="footer-nav-title">Navigacija</h4>
            <ul className="footer-nav-list">
              {footerLinks.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="footer-link">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="footer-contact">
            <h4 className="footer-nav-title">Kontakt</h4>
            <div className="contact-info">
              <a href={`mailto:${brandInfo.email}`} className="contact-item">
                <Mail size={16} />
                <span>
                  <span className="contact-label">Kancelarija:</span>
                  {brandInfo.email}
                </span>
              </a>
              <a href={`mailto:${brandInfo.orderEmail}`} className="contact-item">
                <Mail size={16} />
                <span>
                  <span className="contact-label">Porudžbine:</span>
                  {brandInfo.orderEmail}
                </span>
              </a>
              <a href={`tel:${brandInfo.phones[0].replace(/\s/g, '')}`} className="contact-item">
                <Phone size={16} />
                <span>
                  <span className="contact-label">Kancelarija:</span>
                  {brandInfo.phones[0]}
                </span>
              </a>
              <a href={`tel:${brandInfo.phones[1].replace(/\s/g, '')}`} className="contact-item">
                <Phone size={16} />
                <span>
                  <span className="contact-label">Maloprodaja:</span>
                  {brandInfo.phones[1]}
                </span>
              </a>
            </div>
            <a
              href={brandInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <Instagram size={20} />
              <span>@premiumputer</span>
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">{brandInfo.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
